import type { EventRecordCapabilitiesDto } from "@/generated/model";

/**
 * Offer nothing when the server did not say — never crash the table.
 *
 * Relocated out of EventsHubPage so the acknowledgement surfaces can share the
 * same all-false default. Keeping it here rather than inlining a second copy
 * matters because the failure mode is asymmetric: a web build ahead of core-api
 * that defaults to `true` would render actions the API will reject, whereas
 * defaulting to `false` hides a menu until the deploy catches up.
 */
export const NO_EVENT_RECORD_CAPABILITIES: EventRecordCapabilitiesDto = {
  canAcknowledge: false,
  canRespondToRequest: false,
  canResolve: false,
  canArchive: false,
  canRestore: false,
  canReopen: false,
  canDelete: false,
  canRequestAcknowledgement: false,
};
